import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Buttons used through out the service.
 */
class BasicButton extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.oneOf(['orange', 'darkgrey', 'light', 'lightblue', 'transparent']),
    disabled: PropTypes.bool,
    /** Turns button into an anchor link */
    href: PropTypes.string,
    icon: PropTypes.string,
    isLoading: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'condensed', 'wide']),
    onClick: PropTypes.func,
  };

  render() {
    const {
      children,
      className,
      color,
      disabled,
      href,
      icon,
      isLoading,
      size,
      ...props
    } = this.props;

    const classes = [
      'ea-button',
      { 'ea-button--disabled': !!disabled },
      { 'ea-button--small': size === 'small' },
      { 'ea-button--condensed': size === 'condensed' },
      { 'ea-button--wide': size === 'wide' },
      { 'ea-button--icon': !!icon },
      { 'ea-icon': !!icon },
      color ? `ea-button--${color}` : null,
      icon ? `ea-icon--${icon}` : null,
      { 'ea-button--loading': isLoading },
    ];

    if (href) {
      return (
        <a className={classnames(classes, className)} href={href} {...props}>
          {children}
          {isLoading && this.loadingIndicator()}
        </a>
      );
    }

    return (
      <button className={classnames(classes, className)} disabled={disabled} {...props}>
        {children}
        {isLoading && this.loadingIndicator()}
      </button>
    );
  }

  loadingIndicator() {
    return <span className="ea-loading ea-loading--small" aria-label="loading.." />;
  }
}

export { BasicButton };
export default BasicButton;



// WEBPACK FOOTER //
// ./web/js/components/react-patterns/Button.js